import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import { theme } from "./styles/theme";
import App from "./App";
import { QueryClientProvider, QueryClient } from "react-query";
import NotificationAlert from "./components/Shared/NotificationAlert";
import AppContextProvider from "./contexts/AppContext";
import AuthContextProvider from "./contexts/AuthContext";
import NotificationContextProvider from "./contexts/NotificationContext";
import ConfirmationContextProvider from "./contexts/ConfirmationContext";
import ActionPopperContextProvider from "./contexts/ActionPopperContext";

import "./styles/index.scss";

const root = ReactDOM.createRoot(document.getElementById("root")!);

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

root.render(
  <ThemeProvider theme={theme}>
    <QueryClientProvider client={queryClient}>
      <NotificationContextProvider>
        <AuthContextProvider>
          <AppContextProvider>
            <ConfirmationContextProvider>
              <ActionPopperContextProvider>
                <App />
              </ActionPopperContextProvider>
            </ConfirmationContextProvider>
          </AppContextProvider>
        </AuthContextProvider>
        <NotificationAlert />
      </NotificationContextProvider>
    </QueryClientProvider>
  </ThemeProvider>
);
